const Checkbox = ({ id, checked, onCheck, label }) => {
  const handleChange = () => {
    console.log("Checkbox handleChange id " + id);
    onCheck(id);
  };

  return (
    <label className="inline-flex items-center gap-2 text-sm text-stone-800">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        className="h-4 w-4 rounded border-stone-300 text-teal-700 focus:ring-teal-600"
      />
      {label}
    </label>
  );
};

export default Checkbox;
